/** The one look a chosen option gets, so "on" answers the same way in every control. */
export const SELECTED_TOGGLE =
  'data-[state=on]:border-primary data-[state=on]:bg-primary/10 data-[state=on]:text-primary';
